var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCheck2 = function SvgCircleCheck2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.398c5.854 0 10.6 4.746 10.6 10.6s-4.746 10.6-10.6 10.6-10.6-4.746-10.6-10.6 4.746-10.6 10.6-10.6m0 1.2a9.4 9.4 0 1 0 0 18.801 9.4 9.4 0 0 0 0-18.801m4.647 6.047a.5.5 0 1 1 .707.707l-6 6a.5.5 0 0 1-.707 0l-3-3a.5.5 0 0 1 .707-.707L11 14.29z"
  })));
};
export default SvgCircleCheck2;